import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "flex items-center text-black text-lg" };
var _hoisted_2 = { class: "bg-white dark:bg-gray-900" };
var _hoisted_3 = { class: "py-8 px-4 mx-auto max-w-2xl lg:py-16" };
var _hoisted_4 = { action: "#" };
var _hoisted_5 = { class: "grid gap-4 sm:grid-cols-2 sm:gap-6" };
var _hoisted_6 = { class: "sm:col-span-2" };
var _hoisted_7 = {
    for: "name-link",
    class: "block mb-3 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_8 = ["placeholder"];
var _hoisted_9 = {
    for: "url-link",
    class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_10 = ["placeholder"];
var _hoisted_11 = {
    for: "url-link",
    class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_12 = ["placeholder"];
var _hoisted_13 = { class: "flex justify-between" };
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import { reactive, ref } from "vue";
import { Modal } from "flowbite-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'linkPersonaliCreate',
    props: {
        index: {}
    },
    emits: ["cancel"],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var showLoading = ref(false);
        var newLink = reactive({ link: '', name: '', id_paziente: patient.value.id_paziente, linkid: 0 });
        function saveLinkPersonali() {
            showLoading.value = true;
            var addedlink = ref(newLink);
            patient.value.links.push(addedlink.value);
            localStorage.setItem('patient', JSON.stringify(patient.value));
            store.savePaziente("links", addedlink.value.linkid);
            // store.refreshScheda(store.patient.id_paziente);
            emit('cancel');
            showLoading.value = false;
        }
        return function (_ctx, _cache) {
            var _component_LoadingComponent = _resolveComponent("LoadingComponent");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (showLoading.value)
                    ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
                    : _createCommentVNode("", true),
                _createVNode(_unref(Modal), {
                    onClose: _cache[3] || (_cache[3] = function ($event) { return (_ctx.$emit('cancel')); })
                }, {
                    header: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('link_personali_form.Aggiungi il link')), 1)
                    ]; }),
                    body: _withCtx(function () { return [
                        _createElementVNode("section", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("form", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, [
                                        _createElementVNode("div", _hoisted_6, [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("link_personali_form.Nome Link")), 1),
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((newLink.name) = $event); }),
                                                    type: "text",
                                                    id: "name-link",
                                                    class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                    placeholder: _ctx.$t('link_personali_form.Inserisci qui il nome del link'),
                                                    required: ""
                                                }, null, 8, _hoisted_8), [
                                                    [_vModelText, newLink.name]
                                                ])
                                            ]),
                                            _createElementVNode("div", null, [
                                                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("link_personali_form.URL")), 1),
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((newLink.link) = $event); }),
                                                    type: "text",
                                                    id: "url-link",
                                                    class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                    placeholder: _ctx.$t('link_personali_form.Inserisci qui l URL'),
                                                    required: ""
                                                }, null, 8, _hoisted_10), [
                                                    [_vModelText, newLink.link]
                                                ])
                                            ]),
                                            _createElementVNode("div", null, [
                                                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("link_personali_form.DNAME")), 1),
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((newLink['descrizione']) = $event); }),
                                                    type: "text",
                                                    id: "url-link",
                                                    class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                    placeholder: _ctx.$t('link_personali_form.Desc'),
                                                    required: ""
                                                }, null, 8, _hoisted_12), [
                                                    [_vModelText, newLink['descrizione']]
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]; }),
                    footer: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("button", {
                                onClick: saveLinkPersonali,
                                type: "button",
                                class: "w-full mt-4 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                            }, _toDisplayString(_ctx.$t("link_personali_form.Salva il link")), 1)
                        ])
                    ]; }),
                    _: 1
                })
            ], 64));
        };
    }
});
